import enLocale from 'date-fns/locale/en-US';
import jaLocale from 'date-fns/locale/ja';

export const localeMap = {
    en: enLocale,
    ja: jaLocale,
};

Object.freeze(localeMap);

/*　★★ */
export const CateGetNameOfCategoryByFirstStr = {
    "北海道": '都道府県',
};
Object.freeze(CateGetNameOfCategoryByFirstStr);



export const localeCancelLabelMap = {
    en: 'cancel',
    ja: 'キャンセル',
};

Object.freeze(localeCancelLabelMap);

export const localeHelperTextMap = {
    en: 'Invalid Date Format',
    ja: '無効な日付形式',
};

Object.freeze(localeHelperTextMap);

export const APIErrors = {
    badRequest: 'BAD_REQUEST',
    authExpired: 'AUTH_EXPIRED',
    permissionDenied: 'PERMISSION_DENIED',
    server: 'SERVER_ERROR',
    maitenance: 'MAINTENANCE_ERROR',
    network: 'NETWORK_ERROR',
};

Object.freeze(APIErrors);

export const Role = {
    admin: 2,
    viewer: 0,
    organizer: 1,
    operatorAdmin: 4,
    masterAdmin: 3,
};

Object.freeze(Role);

export const viewerPerType = {
    disable: 0,
    onlyEvent: 1,
    onlySeminar: 2,
    bothType: 3,
};

Object.freeze(viewerPerType);

export const organizerPerType = {
    disable: 0,
    onlyEvent: 1,
    onlySeminar: 2,
    bothType: 3,
};

Object.freeze(organizerPerType);

export const boothType = {
    0: 'disable',
    1: 'small_zone',
    2: 'standard_zone',
    3: 'big_zone',
};

Object.freeze(boothType);

export const extension = {
    image: {
        accept: '.jpe, .jpg, .jpeg, .png',
        extRegex: /\.(?:(jpe?g?)|(png))$/g,
        size: 15,
    },
    video: {
        accept: '.mp4, .mov, .webm, .mkv, .wmv, .flv',
        extRegex: /\.(?:(mov)|(mp4)|(webm)|(mkv)|(wmv)|(flv))$/g,
        size: 2048,
    },
    audio: {
        accept: '.mp3, .aac, .flac',
        extRegex: /\.(?:(mp3)|(aac)|(flac))$/g,
        size: 2048,
    },
    document: {
        accept: '.docx, .txt, .pdf, .xls, .xlsx,',
        extRegex: /\.(?:(docx)|(txt)|(pdf)|(xls)|(xlsx))$/g,
        size: 15,
    },
    html: {
        accept: '.html',
        extRegex: /\.(?:(html))$/g,
        size: 15,
    },
};

Object.freeze(extension);

export const organizerType = {
    1: '展示会のみ',
    2: 'セミナーのみ',
    3: '展示会・セミナーの両方',
};

Object.freeze(organizerType);

export const statusType = {
    ja: {
        0: '承認待ち中',
        1: '承認済み',
        2: '拒否済み',
    },
    en: {
        0: 'Waiting for approval',
        1: 'Approved',
        2: 'Rejected',
    },
};

Object.freeze(statusType);

export const statusApprove = {
    AWAITING_APPROVAL: 0,
    APPROVED: 1,
    REJECTED: 2,
};

Object.freeze(statusApprove);

export const locationOption = {
    ja: {
        0: '',
        1: '日本',
        2: 'アイスランド',
        3: 'アイルランド',
        4: 'アゼルバイジャン',
        5: 'アフガニスタン',
        6: 'アメリカ合衆国',
        7: 'アラブ首長国連邦',
        8: 'アルジェリア',
        9: 'アルゼンチン',
        10: 'アルバニア',
        11: 'アルメニア',
        12: 'アンゴラ',
        13: 'アンティグア・バーブーダ',
        14: 'アンドラ',
        15: 'イエメン',
        16: 'イタリア',
        17: 'イラク',
        18: 'イラン',
        19: 'インド',
        20: 'インドネシア',
        21: 'ウガンダ',
        22: 'ウクライナ',
        23: 'ウズベキスタン',
        24: 'ウルグアイ',
        25: 'エクアドル',
        26: 'エジプト',
        27: 'エストニア',
        28: 'エスワティニ',
        29: 'エチオピア',
        30: 'エリトリア',
        31: 'エルサルバドル',
        32: 'オーストラリア',
        33: 'オーストリア',
        34: 'オマーン',
        35: 'オランダ',
        36: 'ガーナ',
        37: 'カーボヴェルデ',
        38: 'ガイアナ',
        39: 'カザフスタン',
        40: 'カタール',
        41: 'カナダ',
        42: 'ガボン',
        43: 'カメルーン',
        44: 'ガンビア',
        45: 'カンボジア',
        46: 'ギニア',
        47: 'ギニアビサウ',
        48: 'キプロス',
        49: 'キューバ',
        50: 'ギリシャ',
        51: 'キリバス',
        52: 'キルギス',
        53: 'グアテマラ',
        54: 'クウェート',
        55: 'クック諸島',
        56: 'グレナダ',
        57: 'クロアチア',
        58: 'ケニア',
        59: 'コートジボワール',
        60: 'コスタリカ',
        61: 'コソボ',
        62: 'コモロ',
        63: 'コロンビア',
        64: 'コンゴ共和国',
        65: 'コンゴ民主共和国',
        66: 'サウジアラビア',
        67: 'サモア',
        68: 'サントメ・プリンシペ',
        69: 'ザンビア',
        70: 'サンマリノ',
        71: 'シェラレオネ',
        72: 'ジブチ',
        73: 'ジャマイカ',
        74: 'シャンマー',
        75: 'ジョージア',
        76: 'シリア',
        77: 'シンガポール',
        78: 'ジンバブエ',
        79: 'スーダン',
        80: 'スイス',
        81: 'スウェーデン',
        82: 'スペイン',
        83: 'スリナム',
        84: 'スリランカ',
        85: 'スロバキア',
        86: 'スロベニア',
        87: 'セネガル',
        88: 'セルビア',
        89: 'セントクリストファー・ネーヴィス',
        90: 'セントビンセント',
        91: 'セントルシア',
        92: 'ソマリア',
        93: 'ソロモン諸島',
        94: 'タイ',
        95: 'タジキスタン',
        96: 'タンザニア',
        97: 'チェコ',
        98: 'チャド',
        99: 'チュニジア',
        100: 'チリ',
        101: 'ツバル',
        102: 'デンマーク',
        103: 'トーゴ',
        104: 'ドイツ',
        105: 'ドミニカ共和国',
        106: 'ドミニカ国',
        107: 'トリニダード・トバゴ',
        108: 'トルクメニスタン',
        109: 'トルコ',
        110: 'トンガ',
        111: 'ナイジェリア',
        112: 'ナウル',
        113: 'ナミビア',
        114: 'ニウエ',
        115: 'ニカラグア',
        116: 'ニジェール',
        117: 'ニュージーランド',
        118: 'ネパール',
        119: 'ノルウェー',
        120: 'バーレーン',
        121: 'ハイチ',
        122: 'パキスタン',
        123: 'バチカン',
        124: 'パナマ',
        125: 'バヌアツ',
        126: 'バハマ',
        127: 'パプアニューギニア',
        128: 'パラオ',
        129: 'パラグアイ',
        130: 'バルバドス',
        131: 'パレスチナ',
        132: 'ハンガリー',
        133: 'バングラデシュ',
        134: 'ブータン',
        135: 'フィジー',
        136: 'フィリピン',
        137: 'フィンランド',
        138: 'ブラジル',
        139: 'フランス',
        140: 'ブリーズ',
        141: 'ブルガリア',
        142: 'ブルキナファン',
        143: 'ブルンジ',
        144: 'ベトナム',
        145: 'ベナン',
        146: 'ベネズエラ',
        147: 'ベラルーシ',
        148: 'ペルー',
        149: 'ベルギー',
        150: 'ポーランド',
        151: 'ボスニア・ヘルツェゴビナ',
        152: 'ボツワナ',
        153: 'ボリビア',
        154: 'ポルトガル',
        155: 'ホンジュラス',
        156: 'マーシャル',
        157: 'マカオ',
        158: 'マダガスカル',
        159: 'マラウイ',
        160: 'マリ',
        161: 'マルタ',
        162: 'マレーシア',
        163: 'ミクロネシア',
        164: 'メキシコ',
        165: 'モーシェル',
        166: 'モーリシャス',
        167: 'モーリタニア',
        168: 'モザンビーク',
        169: 'モナコ',
        170: 'モルディブ',
        171: 'モルドバ',
        172: 'モロッコ',
        173: 'モンゴル',
        174: 'モンテネグロ',
        175: 'ヨルダン',
        176: 'ラオス',
        177: 'ラトビア',
        178: 'リトアニア',
        179: 'リビア',
        180: 'リヒテンシュタイン',
        181: 'リベリア',
        182: 'ルーマニア',
        183: 'ルクセンブルク',
        184: 'ルワンダ',
        185: 'レソト',
        186: 'レバノン',
        187: 'ロシア',
        188: '中国',
        189: '中央アフリカ',
        190: '北マケドニア',
        191: '南アフリカ',
        192: '南スーダン',
        193: '台湾',
        194: '東ティモール',
        195: '英国',
        196: '赤道ギニア',
        197: '韓国',
        198: '香港',
    },
    en: {
        0: '',
        1: 'Japan',
        2: 'Iceland',
        3: 'Ireland',
        4: 'Azerbaijan',
        5: 'Afghanistan',
        6: 'United States Of America',
        7: 'United Arab Emirates',
        8: 'Algeria',
        9: 'Argentina',
        10: 'Albania',
        11: 'Armenia',
        12: 'Angola',
        13: 'Antigua And Barbuda',
        14: 'Andorra',
        15: 'Yemen',
        16: 'Italy',
        17: 'Iraq',
        18: 'Iran',
        19: 'India',
        20: 'Indonesia',
        21: 'Uganda',
        22: 'Ukraine',
        23: 'Uzbekistan',
        24: 'Uruguay',
        25: 'Ecuador',
        26: 'Egypt',
        27: 'Estonia',
        28: 'Eswatini',
        29: 'Ethiopia',
        30: 'Eritrea',
        31: 'El Salvador',
        32: 'Australia',
        33: 'Austria',
        34: 'Oman',
        35: 'Netherlands',
        36: 'Ghana',
        37: 'Cape Verde',
        38: 'Guyana',
        39: 'Kazakhstan',
        40: 'Qatar',
        41: 'Canada',
        42: 'Gabon',
        43: 'Cameroon',
        44: 'Gambia',
        45: 'Cambodia',
        46: 'Guinea',
        47: 'Guinea-Bissau',
        48: 'Cyprus',
        49: 'Cuba',
        50: 'Greece',
        51: 'Kiribati',
        52: 'Kyrgyzstan',
        53: 'Guatemala',
        54: 'Kuwait',
        55: 'Cook Islands',
        56: 'Grenada',
        57: 'Croatia',
        58: 'Kenya',
        59: 'Ivory Coast',
        60: 'Costa Rica',
        61: 'Kosovo',
        62: 'Comoros',
        63: 'Columbia',
        64: 'Republic Of The Congo',
        65: 'Democratic Republic Of The Congo',
        66: 'Saudi Arabia',
        67: 'Samoa',
        68: 'Sao Tome And Principe',
        69: 'Zambia',
        70: 'San Marino',
        71: 'Sierra Leone',
        72: 'Djibouti',
        73: 'Jamaica',
        74: 'Shamma',
        75: 'Georgia',
        76: 'Syria',
        77: 'Singapore',
        78: 'Zimbabwe',
        79: 'Sudan',
        80: 'Switzerland',
        81: 'Sweden',
        82: 'Spain',
        83: 'Suriname',
        84: 'Sri Lanka',
        85: 'Slovakia',
        86: 'Slovenia',
        87: 'Senegal',
        88: 'Serbia',
        89: 'St Kitts And Nevis',
        90: 'St Vincent',
        91: 'Saint Lucia',
        92: 'Somalia',
        93: 'Solomon Islands',
        94: 'Sea ​​Bream',
        95: 'Tajikistan',
        96: 'Tanzania',
        97: 'Czech Republic',
        98: 'Chad',
        99: 'Tunisia',
        100: 'Chile',
        101: 'Tuvalu',
        102: 'Denmark',
        103: 'Togo',
        104: 'Germany',
        105: 'Dominican Republic',
        106: 'Dominica',
        107: 'Republic Of Trinidad And Tobago',
        108: 'Turkmenistan',
        109: 'Turkey',
        110: 'Tonga',
        111: 'Nigeria',
        112: 'Nauru',
        113: 'Namibia',
        114: 'Niue',
        115: 'Nicaragua',
        116: 'Niger',
        117: 'New Zealand',
        118: 'Nepal',
        119: 'Norway',
        120: 'Bahrain',
        121: 'Haiti',
        122: 'Pakistan',
        123: 'Vatican',
        124: 'Panama',
        125: 'Vanuatu',
        126: 'Bahamas',
        127: 'Papua New Guinea',
        128: 'Palau',
        129: 'Paraguay',
        130: 'Barbados',
        131: 'Palestine',
        132: 'Hungary',
        133: 'Bangladesh',
        134: 'Bhutan',
        135: 'Fiji',
        136: 'Philippines',
        137: 'Finland',
        138: 'Brazil',
        139: 'France',
        140: 'Breeze',
        141: 'Bulgaria',
        142: 'Burkina Fan',
        143: 'Burundi',
        144: 'Vietnam',
        145: 'Benin',
        146: 'Venezuela',
        147: 'Belarus',
        148: 'Peru',
        149: 'Belgium',
        150: 'Poland',
        151: 'Bosnia-Herzegovina',
        152: 'Botswana',
        153: 'Bolivia',
        154: 'Portugal',
        155: 'Honduras',
        156: 'Marshall',
        157: 'Macau',
        158: 'Madagascar',
        159: 'Malawi',
        160: 'Mali',
        161: 'Malta',
        162: 'Malaysia',
        163: 'Micronesia',
        164: 'Mexico',
        165: 'Mochelle',
        166: 'Mauritius',
        167: 'Mauritania',
        168: 'Mozambique',
        169: 'Monaco',
        170: 'Maldives',
        171: 'Moldova',
        172: 'Morocco',
        173: 'Mongolia',
        174: 'Montenegro',
        175: 'Jordan',
        176: 'Laos',
        177: 'Latvia',
        178: 'Lithuania',
        179: 'Libya',
        180: 'Liechtenstein',
        181: 'Liberia',
        182: 'Romania',
        183: 'Luxembourg',
        184: 'Rwanda',
        185: 'Lesotho',
        186: 'Lebanon',
        187: 'Russia',
        188: 'China',
        189: 'Central Africa',
        190: 'North Macedonia',
        191: 'South Africa',
        192: 'South Sudan',
        193: 'Taiwan',
        194: 'East Timor',
        195: 'Uk',
        196: 'Equatorial Guinea',
        197: 'Korea',
        198: 'Hong Kong',
    },
};

Object.freeze(locationOption);

export const jobOption = {
    0: '',
    1: '製造業１（電気・機械・電子精密）',
    2: '製造学２（化学・新素材）',
    3: '製造学３（食品・飲料）',
    4: 'IT・コンピューター・情報通信',
    5: '農学・林学・漁学',
    6: '鉱学・エネルギー・インフラ',
    7: '建設・不動産・オフィス',
    8: '流通・運輸・販売',
    9: '教育・出版・マスコミ',
    10: '医療・福祉',
    11: '外食・宿伯・旅行・娯楽',
    12: '金融・保険',
    13: '官公庁',
    14: 'その他',
};

Object.freeze(jobOption);

export const purposeOption = {
    ja: {
        0: '',
        1: '導入したい商品・サービス探し',
        2: '技術開発でのヒント探し',
        3: '開発商品の部品・機械探し',
        4: '購入商品・サービスを見るため',
        5: '情報収集・資料集め',
        6: '取引企業への挨拶',
        7: '担当者と直接に聞きたい事がある',
        8: '目的なくぶりらと',
    },
    en: {
        0: '',
        1: 'To find products and services to introduce',
        2: 'To look for tips in technology development',
        3: 'To find parts and machinery for development',
        4: 'To view products and services',
        5: 'To gather information and materials',
        6: 'To greet business partners',
        7: 'I have a question I want to ask my contact person directly.',
        8: 'not especially',
    },
};

Object.freeze(purposeOption);

export const optionRegis = { event: '1', seminarAndEvent: '3', seminar: '2' };

Object.freeze(optionRegis);

export const MEDIA_TYPE = {
    IMAGE: 0,
    AUDIO: 1,
    VIDEO: 2,
};

Object.freeze(MEDIA_TYPE);

export const BOOTH_TYPE = {
    DISABLE: 0,
    SMALL: 1,
    STANDARD: 2,
    BIG: 3,
    GRAND: 4,
};

Object.freeze(BOOTH_TYPE);

export const SEMINAR_STATUS_VALUE = {
    NOTSTART: 0,
    START: 1,
    RUNING: 2,
    FINISH: 3,
};

Object.freeze(SEMINAR_STATUS_VALUE);

export const SEMINAR_STATUS_TEXT = {
    ja: {
        0: '未開催',
        1: 'もうすぐ開催',
        2: '開催中',
        3: '終了済み',
    },
    en: {
        0: 'Not held yet',
        1: 'Soon to hold',
        2: 'Holding',
        3: 'Completed',
    },
};

Object.freeze(SEMINAR_STATUS_TEXT);

export const PAID = {
    ja: {
        UNPAID: '未支払い',
        PAIDED: '支払い済み',
    },
    en: {
        UNPAID: 'Not paid yet',
        PAIDED: 'Paid',
    },
};

Object.freeze(PAID);

export const EVENT_EFFECT_DURATION = {
    BEFORE: 14,
    AFTER: 7,
};

Object.freeze(EVENT_EFFECT_DURATION);

export const SERVER_CHAR_LIMIT = {
    TEXT_FIELD: 500,
};

Object.freeze(SERVER_CHAR_LIMIT);

export const LOCAL_STORAGE = {
    SELECTED_COMPANIES: 'selectedCompanyIDs',
};

Object.freeze(LOCAL_STORAGE);

export const BUSINESS_CONTACT = {
    hide: {
        text: '表示しない',
        mainValue: '0',
        extraValue: 'false',
    },
    show: {
        text: '表示する',
        mainValue: '1',
        extraValue: 'true',
    },
};

export const BUSINESS_CONTACT_VIEW = {
    false: '表示しない',
    true: '表示する',
};

Object.freeze(BUSINESS_CONTACT_VIEW);

export const BUSINESS_CONTACT_TYPE = {
    BUY: 0,
    NEGOTIATE: 1,
};

Object.freeze(BUSINESS_CONTACT_TYPE);

export const OUTSIDE_LINK = {
    false: '利用しない',
    true: '利用する',
};

Object.freeze(OUTSIDE_LINK);

export const SETTINGS_DISPLAY_PRODUCT_ITEM = {
    display_purchase_link: '商品購入',
    display_has_outside_link: '担当者と直接相談',
    display_document: '資料アップロード',
    display_document_link: '資料請求',
    display_survey_link: 'アンケート',
    display_business_contact: '商談／お問合せ',
    display_outside2_link: '喫茶掲示板ルーム',
    display_outside3_link: '外部リンク',
    display_business_card: '名刺交換',
};

Object.freeze(SETTINGS_DISPLAY_PRODUCT_ITEM);

export const SEMINAR_STATUS = {
    STOP: 1,
    NORMAL: 0,
};

Object.freeze(SEMINAR_STATUS);

export const DISPLAY_BUSINESS_CARD = {
    false: '利用しない',
    true: '利用する',
};

Object.freeze(DISPLAY_BUSINESS_CARD);

export const SEMINAR_STATUS_CHECK = {
    NORMAL: {
        CODE: 1,
        MSG: '通常',
    },
    PAUSED: {
        CODE: 2,
        MSG: '停止中',
    },
    DELETED: {
        CODE: 3,
        MSG: '削除済み',
    },
};

Object.freeze(SEMINAR_STATUS_CHECK);

export const FREE_LOGIN = {
    FREE_ALL: {
        CODE: 2,
        MSG: 'すべてフリー',
    },
    DISABLE_SEMINAR: {
        CODE: 1,
        MSG: 'セミナーのみログイン',
    },
    DISABLE_ALL: {
        CODE: 0,
        MSG: 'しない',
    },
};

Object.freeze(FREE_LOGIN);

export const ORGANIZER_TYPE = {
    DISABLE_ALL: '0',
    EXHIBITION: '1',
    SEMINAR: '2',
    EXHIBITION_AND_SEMINAR: '3',
};

Object.freeze(ORGANIZER_TYPE);

export const LIVESTREAM_STATUS_TEXT = {
    ja: {
        0: '受付開始',
        1: '受付終了',
        2: 'もうすぐ開催',
        3: '開催中',
        4: '終了済み',
    },
    en: {
        0: 'Registration start',
        1: 'Registration deadline',
        2: 'Soon to hold',
        3: 'Holding',
        4: 'Completed',
    },
};

Object.freeze(LIVESTREAM_STATUS_TEXT);

export const LIVESTREAM_STATUS_START = {
    0: 'NOT_START_YET',
    1: 'UP_COMING',
    2: 'RUNNING',
    3: 'FINISH',
};

Object.freeze(LIVESTREAM_STATUS_START);

export const OPTION_CUSTOM_SITE = {
    0: '入場者サイト',
    1: '出展者サイト',
};

Object.freeze(OPTION_CUSTOM_SITE);

export const OPTION_CUSTOM_PAGE_VIEWER = {
    0: 'Livestream',
    1: 'Seminar',
    2: 'Exhibition',
    3: 'Sidebar',
    5: 'Event',
    6: 'Personal Information',
};

Object.freeze(OPTION_CUSTOM_PAGE_VIEWER);

export const OPTION_CUSTOM_PAGE_ORGANIZER = {
    0: 'Livestream',
    1: 'Seminar',
    2: 'Exhibition',
    3: 'Sidebar',
    4: 'Company',
};

Object.freeze(OPTION_CUSTOM_PAGE_ORGANIZER);

export const LIST_LANGUAGE = [
    {
        language: 'en',
        text: '英語',
    },
    {
        language: 'ar',
        text: 'アラビア語',
    },
    {
        language: 'it',
        text: 'イタリア語',
    },
    {
        language: 'es',
        text: 'スペイン語',
    },
    {
        language: 'de',
        text: 'ドイツ語',
    },
    {
        language: 'fr',
        text: 'フランス語',
    },
    {
        language: 'pt',
        text: 'ポルトガル語',
    },
    {
        language: 'la',
        text: 'ラテン語',
    },
    {
        language: 'ko',
        text: '韓国語',
    },
    {
        language: 'zh-TW',
        text: '中国語（繁体）',
    },
];
export const OBJ_LANGUAGE = {
    ar: 'Arabic',
    it: 'Italian',
    es: 'Spanish',
    de: 'German',
    fr: 'French',
    pt: 'Portuguese',
    la: 'Latin',
    ko: 'Korean',
    'zh-TW': 'Chinese (Traditional)',
};
